<div class="page-container">
  <img
    [src]="getErrorImage()"
    alt="Ops! Something went wrong. Please try again"
  />
  <p class="error-page-title">
    {{ error.title }}
  </p>
  <p class="error-page-text">
    @if (statusCode !== 401) {
      {{ error.message }}
    }
    @if (statusCode === 401) {
      <span>
        <a [href]="redirectLoginUrl">Please click here to login</a>
      </span>
    }
  </p>
</div>
